/**
 * An element that is created off screen may not have its size computed yet.
 * This procedure will register a temporary ResizeObserver and watch for the
 * clientWidth and clientHeight to become non-zero.
 */
export const sizeReady = (elt: HTMLElement, fn: () => void) => {
    if(elt.clientWidth > 0 && elt.clientHeight > 0) {
        fn();
    } else {
        const observer = new ResizeObserver(() => {
            if(elt.clientWidth > 0 && elt.clientHeight > 0) {
                observer.disconnect();
                fn();
            }
        });
        observer.observe(elt);
    }
}

export default sizeReady;
